/**
 * Display of a campaign's rep outreach: were its tickets worked, and did the
 * customers a rep reached out to order? See
 * docs/features/campaign-rep-outreach/.
 */

/** "25%" share of `customers` who ordered; "—" when there were none. */
export function formatOrderedShare(ordered: number, customers: number): string {
  if (customers === 0) return "—";
  return `${Math.round((ordered / customers) * 100)}%`;
}
